import { useEffect } from 'react'
import useStore from 'reusable/mobx-store-utils'

function useKeyInputListener(action: () => void, code: string) {
   const useKeyInputListenerStore = useStore(sp => ({
      input: [] as string[],
      onKeyUp: (e: KeyboardEvent) => {
         if (e.key === ' ') {
            return
         }
         useKeyInputListenerStore.input.push(e.key)
         useKeyInputListenerStore.input.splice(-sp.code.length - 1, useKeyInputListenerStore.input.length - sp.code.length)
         if (useKeyInputListenerStore.input.join('').toLowerCase().replace(/ /g, '').includes(sp.code)) {
            action()
         }
      }
   }), { code: code.replace(/ /g, '').toLowerCase() })

   useEffect(() => {
      document.addEventListener('keyup', useKeyInputListenerStore.onKeyUp)
      return () => {
         document.removeEventListener('keyup', useKeyInputListenerStore.onKeyUp)
      }
   }, [useKeyInputListenerStore.onKeyUp])
}

export default useKeyInputListener